



























































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import SearchBar from '@/components/next/SearchBar.vue';
import VoteButton from '../components/VoteButtonList.vue';
import { Icon, List, Toast } from 'vant';
import { getList } from '../api/index';
import { inAppAlertLogin } from '@/common/ts/common';
import { isWeiXin } from '@/common/ts/common';
import { unionIdIsBind } from '@/api/api';

Vue.use(Icon).use(List);
@Component({
  components: {
    SearchBar,
    VoteButton,
  },
})
export default class People extends Vue {
  @Prop({ default: 0 }) listNumber!: number;
  activity: number = 0;
  tab: any = [{ text: '人物奖项' }, { text: '企业奖项' }];
  list: any = [];
  page = 1;
  loading = false;
  finished = false;
  loadingStatus = true;
  show: boolean = false;
  refreshing: boolean = false;
  search = '';
  placeholder: string = '请输入姓名或编号';
  created() {
    setTimeout(() => {
      this.show = true;
    }, 50);
  }
  userInputChange(e: any) {
    this.show = false;
    setTimeout(() => {
      this.show = true;
    }, 50);
    this.search = e;
    this.page = 1;
    this.list = [];
    this.loading = false;
    this.finished = false;
  }
  changeActivity(index: any) {
    this.show = false;
    if (index) {
      this.placeholder = '请输入名称或编号';
    } else {
      this.placeholder = '请输入名称或编号';
    }
    setTimeout(() => {
      this.show = true;
    }, 50);
    this.activity = index;
    this.page = 1;
    this.list = [];
    this.loading = false;
    this.finished = false;
  }
  onLoad() {
    const workType = this.activity + 1;
    getList(this.page, workType, this.search).then((res: any) => {
        this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data];
    }
    this.loading = false;
  }
  votSuccess(data: any) {
    this.list[data.index].votes = data.num;
  }
  onNavTo(url: string, id: number, index: number) {
    this.$routerThen
      .push({
        url: `${url}?id=${id}`,
      })
      .then((vm) => {
        vm.$on('like', (val: any) => {
          this.list[index].votes++;
        });
      });
  }
  // 点击充值
  async handleTopup() {
    const isIos = window.isIOS;
    const version = window.version;
    const data = {
      type: 2,
      unionId: window.localStorage.getItem('unionid'),
    };
    if (!isWeiXin() && !window.udid) {
      Toast('请在微信或者上游APP打开');
    } else if (isWeiXin()) {
      const res: any = await unionIdIsBind(data);
      if (!res.data) {
        this.$router.push(
          `/BindPhone?url=${encodeURIComponent(location.href)}`,
        );
        return false;
      }
    } else {
      if (isIos) {
        if (version < '5.6.6') {
          Toast('请升级客户端到最新版本！');
          return false;
        }
      }
    }
    // if (!window.udid) {
    //   Toast('请进入上游新闻app充值送花');
    //   return;
    // }

    // 在app里没有登陆的时候
    if (!isWeiXin()) {
      if (!window.gettoken() || window.gettoken() === 'null') {
        inAppAlertLogin();
        return;
      }
    }

    this.$router.push({
      path: 'user/top-up',
    });
  }
}
